<template>
  <div>
    <div class="bg" v-if="!initFlag">
      <hm-step :steps="steps" :step="step" :disabled-jump="true"></hm-step>
    </div>
    <hm-content class="mt10" v-if="!initFlag">
      <div class="step2-style" v-if="step == 1">
        <div class="title mt10">
          第1步：点击我的企业查看企业ID,并填入下方输入框中
        </div>
        <div
            class="mt10"
            style="
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
            margin-left: 70px;
          "
        >
          配置位置请<a
            :href="'https://hemiao100.yuque.com/docs/share/a3c537b2-9749-48f2-b673-aaccf6074094?#'"
            target="_blank"
            style="color: rgba(0, 129, 229, 1)"
        >查看帮助》</a
        >
        </div>
        <el-form
            style="margin-top: 30px"
            ref="initItemRuleForm"
            :model="initItem.ruleForm"
            :rules="initItem.rules"
            label-width="100px"
        >
          <el-form-item label="企业ID" prop="corpId">
            <el-input
                clearable
                v-model.trim="initItem.ruleForm.corpId"
                style="width: 380px"
                size="small"
                placeholder="请输入企业ID"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="mt20">
          <el-image
              style="width: 40%"
              src="https://imgcdn.hemiao100.com/ThemePictures/customerService7.png"
              :preview-src-list="[
              'https://imgcdn.hemiao100.com/ThemePictures/customerService7.png',
            ]"
          >
          </el-image>
        </div>
        <div class="mt40 flex flex-center item-center">
          <el-button type="primary" size="small" @click="next(2)">
            下一步</el-button
          >
        </div>
      </div>
      <div class="step1-style" v-if="step == 2">
        <div class="title mt20">第2步：将下方URL地址复制填入输入框</div>
        <div
          class="mt10"
          style="
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
            margin-left: 70px;
          "
        >
          配置位置请<a
            :href="'https://hemiao100.yuque.com/docs/share/a3c537b2-9749-48f2-b673-aaccf6074094?#'"
            target="_blank"
            style="color: rgba(0, 129, 229, 1)"
            >查看帮助》</a
          >
        </div>
        <div class="url">
          <input
            type="text"
            size="small"
            class="urlInput"
            :value="initItem.linkUrl"
            ref="activityListUrl"
          />
          <span style="margin-right: 30px; color: #0081e5">{{
            initItem.linkUrl
          }}</span>
          <el-button
            class="btn"
            type="primary"
            plain
            size="small"
            @click="copyUrl"
            >复制</el-button
          >
        </div>
        <div class="mt20">
          <el-image
            style="width: 40%"
            src="https://imgcdn.hemiao100.com/ThemePictures/customerService1.png"
            :preview-src-list="[
              'https://imgcdn.hemiao100.com/ThemePictures/customerService1.png',
            ]"
          >
          </el-image>
        </div>
        <div class="mt20 flex flex-center item-center">
          <el-button size="small" @click="step = 1"> 上一步</el-button>
          <el-button type="primary" size="small"  @click="step = 3">
            下一步</el-button
          >
        </div>
        <div class="mt20">
          <el-image
            style="width: 40%"
            src="https://imgcdn.hemiao100.com/ThemePictures/customerService4.png"
            :preview-src-list="[
              'https://imgcdn.hemiao100.com/ThemePictures/customerService4.png',
            ]"
          >
          </el-image>
        </div>
        <div class="mt20">
          <el-image
            style="width: 40%"
            src="https://imgcdn.hemiao100.com/ThemePictures/customerService5.png"
            :preview-src-list="[
              'https://imgcdn.hemiao100.com/ThemePictures/customerService5.png',
            ]"
          >
          </el-image>
        </div>
        <div class="mt20">
          <el-image
            style="width: 40%"
            src="https://imgcdn.hemiao100.com/ThemePictures/customerService6.png"
            :preview-src-list="[
              'https://imgcdn.hemiao100.com/ThemePictures/customerService6.png',
            ]"
          >
          </el-image>
        </div>
      </div>
      <div class="step2-style" v-if="step == 3">
        <div class="title mt10">
          第3步：点击「随机获取」并将对应的Token、AESKey复制填入下方输入框中，点击「完成」
        </div>
        <div
          class="mt10"
          style="
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
            margin-left: 70px;
          "
        >
          配置位置请<a
            :href="'https://hemiao100.yuque.com/docs/share/a3c537b2-9749-48f2-b673-aaccf6074094?#'"
            target="_blank"
            style="color: rgba(0, 129, 229, 1)"
            >查看帮助》</a
          >
        </div>
        <el-form
          style="margin-top: 30px"
          ref="initItemRuleForm"
          :model="initItem.ruleForm"
          :rules="initItem.rules"
          label-width="100px"
        >
          <el-form-item label="Token" prop="token">
            <el-input
              clearable
              v-model.trim="initItem.ruleForm.token"
              size="small"
              style="width: 380px"
              placeholder="请输入Token"
            ></el-input>
          </el-form-item>
          <el-form-item label="AESKey" prop="encodingAESKey">
            <el-input
              clearable
              v-model.trim="initItem.ruleForm.encodingAESKey"
              style="width: 380px"
              size="small"
              placeholder="请输入AESKey"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="mt20">
          <el-image
            style="width: 40%"
            src="https://imgcdn.hemiao100.com/ThemePictures/customerService2.jpg"
            :preview-src-list="[
              'https://imgcdn.hemiao100.com/ThemePictures/customerService2.jpg',
            ]"
          >
          </el-image>
        </div>
        <div class="mt40 flex flex-center item-center">
          <el-button size="small" @click="step = 2"> 上一步</el-button>
          <el-button type="primary" size="small" @click="next(4)">
            下一步</el-button
          >
        </div>
      </div>
      <div class="step2-style" v-if="step == 4">
        <div class="title mt10">第4步：点击查看Secret,并填入下方输入框中</div>
        <div
          class="mt10"
          style="
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
            margin-left: 70px;
          "
        >
          配置位置请<a
            :href="'https://hemiao100.yuque.com/docs/share/a3c537b2-9749-48f2-b673-aaccf6074094?#'"
            target="_blank"
            style="color: rgba(0, 129, 229, 1)"
            >查看帮助》</a
          >
        </div>
        <el-form
          style="margin-top: 30px"
          ref="initItemRuleForm"
          :model="initItem.ruleForm"
          :rules="initItem.rules"
          label-width="100px"
        >
          <el-form-item label="Secret" prop="secret">
            <el-input
              clearable
              v-model.trim="initItem.ruleForm.secret"
              style="width: 380px"
              size="small"
              placeholder="请输入Secret"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="mt20">
          <el-image
            style="width: 40%"
            src="https://imgcdn.hemiao100.com/ThemePictures/customerService3.png"
            :preview-src-list="[
              'https://imgcdn.hemiao100.com/ThemePictures/customerService3.png',
            ]"
          >
          </el-image>
        </div>
        <div class="mt40 flex flex-center item-center">
          <el-button size="small" @click="step = 3"> 上一步</el-button>
          <el-button type="primary" size="small" @click="next(5)">
            下一步</el-button
          >
        </div>
      </div>
      <div class="step2-style" v-if="step == 5">
        <div class="flex flex-center" style="margin-top: 90px">
          <div>
            <div class="flex flex-center">
              <div class="yuan text-center">
                <span style="font-size: 32px" class="hmicon icon-duigou"></span>
              </div>
            </div>
            <div class="text-center mt10 suc">安装成功</div>
            <div class="text-center mt10">
              您的客服已经安装成功，您可以点击以下操作
            </div>
            <div class="text-center mt40">
              <el-button type="primary" size="small" @click="initFlag = true">
                首 页</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </hm-content>

    <!-----------------------    初始化结束    ---------------------------------->

    <div class="bg p20" v-if="initFlag">
      <div class="title mt10">
        客服分组 <span class="desc">（最多可创建10个分组）</span>
      </div>
      <div class="flex flex-wrap item-center mt40" style="flex-wrap: wrap">
        <div
          class="content-style has-style flex"
          v-for="(v, i) in customerGroupList"
          :key="i"
        >
          <div class="flex flex-center item-center mr10" style="width: 50px">
            <el-image
              style="width: 50px; height: 50px"
              :src="v.avatar || defultImg"
            ></el-image>
          </div>
          <div class="flex-1 flex flex-column flex-around">
            <div style="font-size: 14px">{{ v.name }}</div>
            <div class="blue" style="font-size: 12px">
              {{ customerServiceDesc }}
            </div>
          </div>
          <div
            style="width: 30px"
            class="flex flex-center item-center text-center"
          >
            <div class="flex flex-center item-center text-center">
              <el-dropdown trigger="click" size="small" @command="doMore">
                <el-button
                  type="text"
                  size="small"
                  class="blue"
                  style="font-size: 28px"
                >
                  ...
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, i) in moreList"
                    :key="i"
                    :command="{
                      val: item.val,
                      item: v,
                    }"
                    >{{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div
          class="content-style notHas-style flex flex-center item-center"
          v-if="customerGroupList.length < 10"
          @click="addCustomer"
        >
          <el-button size="small" type="text" style="font-size: 14px"
            >+ 新建客服组</el-button
          >
        </div>
      </div>
    </div>
    <hm-content class="mt10" v-if="initFlag">
      <div class="title mt10">客服策略</div>
      <el-button type="primary" class="bt20" size="small" @click="addStrategy">
        添加策略</el-button
      >
      <el-table
        stripe
        border
        class="mt20"
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
        :key="Math.random()"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="strategyName"
          label="策略名称"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="strategyEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="strategyDel(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          class="mt40"
          :total="total"
          @current-change="paging"
          layout="total,sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <el-dialog
        :title="title"
        :close-on-click-modal="false"
        :visible.sync="addCustomerVisible"
      >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          v-if="addCustomerVisible"
          :rules="rules"
          label-width="120px"
        >
          <el-form-item label="客服组名称" prop="groupName">
            <el-input
              v-model="ruleForm.groupName"
              size="small"
              clearable
              placeholder="请输入客服组名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="账号头像" prop="pic">
            <div v-if="ruleForm.pic" class="flex">
              <div class="mr10 flex item-end priview">
                <el-image
                  class="img"
                  style="width: 106px; height: 106px"
                  :src="ruleForm.pic"
                  alt="logo"
                  :preview-src-list="[ruleForm.pic]"
                />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemove('pic')"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
            <el-upload
              v-else
              class="upload flex"
              ref="upload"
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onError="uploadError"
              :onSuccess="uploadSuccess"
              :beforeUpload="beforeAvatarUpload"
              :onProgress="uploading"
            >
              <div class="flex upload-upload-btn">
                <div class="btn flex flex-column flex-center open-file">
                  <div class="add-wrapper">
                    <span
                      class="hmicon icon-hao pointer"
                      style="margin-right: 0px"
                    ></span>
                  </div>
                  <span class="gray">上传头像</span>
                </div>
              </div>
            </el-upload>
            <div>
              客服账号的头像和名称将会在对话界面展示给客户哦<span
                class="ml10 blue"
                >示例</span
              >
            </div>
          </el-form-item>
          <el-form-item label="预览">
            <div class="content-style has-style flex">
              <div
                class="flex flex-center item-center mr10"
                style="width: 50px"
              >
                <el-image
                  style="width: 50px; height: 50px"
                  :src="ruleForm.pic || defultImg"
                ></el-image>
              </div>
              <div class="flex-1 flex flex-column flex-around">
                <div style="font-size: 14px">{{ ruleForm.groupName }}</div>
                <div class="blue" style="font-size: 12px">
                  {{ customerServiceDesc }}
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="接待客服设置">
            <el-button size="small" type="primary" @click="addEmployee"
              >添加成员</el-button
            >
            <div class="mt20 flex flex-wrap">
              <div
                class="user-style flex item-center"
                v-for="(v, i) in ruleForm.userIds"
                :key="i"
              >
                <el-image
                  style="width: 16px; height: 17px; margin-right: 5px"
                  :src="v.avatar || defultImg"
                ></el-image>
                <span style="margin-right: 10px">{{ v.name }}</span>
                <span class="flex-1">{{ v.mobile }}</span>
                <div
                  class="guanBi hmicon icon-jujue"
                  @click="delUserId(i)"
                ></div>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="btn-wrapper flex flex-center">
          <el-button size="small" type="primary" @click="save">提 交</el-button>
        </div>
      </el-dialog>
      <div v-if="catCustomerVisible">
        <el-dialog
          title="客服分组详情"
          :close-on-click-modal="false"
          :visible.sync="catCustomerVisible"
        >
          <div class="title mt20">客服组信息</div>
          <div class="flex item-center mt20">
            <el-image
              style="width: 50px; height: 50px"
              :src="ruleForm.avatar || defultImg"
              class="mr10"
            ></el-image>
            <div>
              {{ ruleForm.name
              }}<span class="blue">{{ customerServiceDesc }}</span>
            </div>
          </div>
          <div class="flex item-center mt10">
            <span class="mr20 kfService"
              >客服链接：
              <input
                type="text"
                size="small"
                class="urlInput"
                :value="serviceLink"
                ref="serviceLinkUrl"
              />{{ serviceLink }}</span
            >
            <el-button size="small" type="primary" @click="copyServiceLinkUrl"
              >复制链接</el-button
            >
          </div>
          <div class="title mt40">接待客服</div>
          <div class="mt20 flex flex-wrap">
            <div
              class="user-style flex item-center"
              v-for="(v, i) in ruleForm.userIds"
              :key="i"
            >
              <el-image
                style="width: 16px; height: 17px; margin-right: 5px"
                :src="v.avatar || defultImg"
              ></el-image>
              <span class="flex-1" style="margin-right: 10px">{{
                v.name
              }}</span>
              <span style="width: 48%">{{ v.mobile }}</span>
            </div>
          </div>
          <div class="btn-wrapper flex flex-center mt20">
            <el-button
              size="small"
              type="primary"
              @click="catCustomerVisible = false"
              >关 闭</el-button
            >
          </div>
        </el-dialog>
      </div>

      <el-dialog
        :title="strategyTitle"
        :close-on-click-modal="false"
        :visible.sync="strategyVisible"
      >
        <el-form
          :model="strategyRuleForm"
          v-if="strategyVisible"
          ref="strategyRuleForm"
          :rules="strategyRules"
          label-width="100px"
        >
          <el-form-item label="策略名称" prop="strategyName">
            <el-input
              v-model="strategyRuleForm.strategyName"
              size="small"
              clearable
              placeholder="请输入策略名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="策略规则" prop="lastStrategy">
            <div
              class="mb10 flex item-center"
              v-for="(v, i) in strategyRuleForm.ruleList"
              :key="i"
            >
              <div class="flex-1">
                <span>{{ i + 1 }}.</span>
                <el-select
                  v-model="v.memberStrategy"
                  class="ml20"
                  style="width: 135px"
                  size="small"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, i) in memberTypeList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <span class="ml10 mr10">按照</span>
                <el-select
                  v-model="v.ruleStrategy"
                  style="width: 145px"
                  size="small"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, i) in strategyList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <span class="ml10">规则</span>
                <span class="mr10">，由</span>
                <el-select
                  v-model="v.kfStrategy"
                  style="width: 135px"
                  size="small"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, i) in customerGroupList"
                    :key="i"
                    :label="item.name"
                    :value="item.open_kfid"
                  >
                  </el-option>
                </el-select>
                <span class="ml10 mr20" v-if="v.strategy == '4'">接待</span>
              </div>
              <div style="width: 20%">
                <el-button
                  size="small"
                  @click="clickUp(i)"
                  :disabled="i == 0"
                  type="text"
                  class="blue"
                  >上移</el-button
                >
                <el-button
                  size="small"
                  @click="clickDown(i)"
                  :disabled="i == strategyRuleForm.ruleList.length - 1"
                  type="text"
                  class="blue"
                  >下移</el-button
                >
                <el-button size="small" type="text" @click="clickDel(i)"
                  >删除</el-button
                >
              </div>
            </div>
            <el-button
              type="primary"
              style="width: 380px"
              size="small"
              @click="addStrategyRule"
            >
              添加规则</el-button
            >
            <div style="color: #666666; font-size: 12px; margin-top: -5px">
              客户咨询客服的规则按照行号逐条执行，找到接待人后，后续规则不再执行
            </div>
            <div class="mt10 item-center">
              <span>会员找不到规则，由</span>
              <el-select
                v-model="strategyRuleForm.lastStrategy"
                clearable
                style="width: 135px; margin-left: 5px"
                size="small"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, i) in customerGroupList"
                  :key="i"
                  :label="item.name"
                  :value="item.open_kfid"
                >
                </el-option>
              </el-select>
              <span class="ml10">接待</span>
            </div>
          </el-form-item>
          <el-form-item label="策略名称" prop="strategyUrl">
            <div class="mr10 cl-url">
              <input
                type="text"
                size="small"
                class="urlInput"
                :value="strategyRuleForm.strategyUrl"
                ref="strategyUrl"
              />{{ strategyRuleForm.strategyUrl }}
            </div>
            <el-button class="btn-blue" size="small" @click="copyStrategyUrl">
              复制链接</el-button
            >
            <div style="color: #666666; font-size: 12px; margin-top: -5px">
              您可以复制链接到商城、公众号或其他任意地方，客户点击链接按照里面的规则分配客服
            </div>
          </el-form-item>
        </el-form>
        <div class="btn-wrapper flex flex-center">
          <el-button size="small" type="primary" @click="saveStrategy"
            >保 存</el-button
          >
        </div>
      </el-dialog>

      <div v-if="employeeVisible">
        <el-dialog
          title="客服分组详情"
          width="1200px"
          :close-on-click-modal="false"
          :modal-append-to-body="false"
          :visible.sync="employeeVisible"
        >
          <HmEmployeeSelect ref="employeeSelect"></HmEmployeeSelect>
          <div class="btn-wrapper flex flex-center mt40">
            <el-button size="small" type="primary" @click="saveEmployee"
              >保 存</el-button
            >
            <el-button size="small" @click="employeeVisible = false"
              >取 消</el-button
            >
          </div>
        </el-dialog>
      </div>
    </hm-content>
    <hm-content class="mt10" v-if="initFlag">
      <div class="title mt10">客服策略应用</div>
      <el-table
        stripe
        border
        class="mt20"
        ref="table"
        :data="strategyTableList"
        style="width: 100%"
        id="table"
        size="small"
        :key="Math.random()"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="strategyPosition"
          label="应用位置"
        >
        </el-table-column>
        <el-table-column
          label="策略"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-select
                size="small"
                filterable
                clearable
                placeholder="选择策略"
                v-model="scope.row.strategyName"
                class="width-auto mr10"
                @change="strategySelect(scope.row)"
              >
                <el-option
                  v-for="(v, i) in list"
                  :key="i"
                  :label="v.strategyName"
                  :value="v.strategyName"
                ></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </hm-content>
  </div>
</template>

<script>
import HmStep from "@/components/HmStep";
import HmEmployeeSelect from "@/components/HmEmployeeSelect";
import { getLoginUser } from "@/utils/auth";
export default {
  components: { HmStep, HmEmployeeSelect },
  data() {
    const strategyRuleFunc = function (rule, val, callback) {
      if (!this.strategyRuleForm.lastStrategy) {
        callback(new Error("请选择会员找不到规则时的接待客服组"));
      }
      if (
        this.strategyRuleForm.ruleList &&
        this.strategyRuleForm.ruleList.length > 0
      ) {
        let flag = true;
        this.strategyRuleForm.ruleList.forEach((v) => {
          if (!v.memberStrategy || !v.ruleStrategy || !v.kfStrategy) {
            flag = false;
          }
        });
        if (!flag) {
          callback(new Error("请完整选择所有项"));
        }
      }
      callback();
    }.bind(this);
    return {
      customerGroupList: [],
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      defultImg:
        "https://imgcdn.hemiao100.com/ThemePictures/lQLPDhqq_2MDIS1UVLDUu8qI54PtpVFP5iyFUtKa_84_84.png_720x720q90g.jpg",
      moreList: [
        {
          name: "查看",
          val: "cat",
        },
        {
          name: "编辑",
          val: "edit",
        },
      ],
      addCustomerVisible: false,
      ruleForm: {
        groupName: "",
        pic: "",
        userIds: [],
      },
      rules: {
        groupName: [
          { required: true, message: "请输入客服组名称", trigger: "blur" },
        ],
        pic: [{ required: true, message: "请上传头像", trigger: "change" }],
      },
      catCustomerVisible: false,
      initFlag: false,
      step: 1,
      steps: [
        {
          link: "CustomerServiceManage",
          name: "复制企业id到禾苗",
        },
        {
          link: "CustomerServiceManage",
          name: "复制链接到企业微信",
        },
        {
          link: "CustomerServiceManage",
          name: "复制Token、AESKey到禾苗",
        },
        {
          link: "CustomerServiceManage",
          name: "复制密钥到禾苗",
        },
        {
          link: "CustomerServiceManage",
          name: "安装完成",
        },
      ],
      initItem: {
        linkUrl: "",
        ruleForm: {
          token: "",
          encodingAESKey: "",
          corpId: "",
          secret: "",
        },
        rules: {
          token: [{ required: true, message: "请输入Token", trigger: "blur" }],
          encodingAESKey: [
            { required: true, message: "请输入AESKey", trigger: "blur" },
          ],
          secret: [
            { required: true, message: "请输入Secret", trigger: "blur" },
          ],
          corpId: [
            { required: true, message: "请输入企业ID", trigger: "blur" },
          ],
        },
      },
      strategyVisible: false,
      strategyRuleForm: {
        strategyName: "",
        ruleList: [],
        lastStrategy: "",
        strategyUrl: "",
      },
      memberTypeList: [
        {
          label: "plus会员",
          value: "plus",
        },
        {
          label: "普通会员",
          value: "no_plus",
        },
        {
          label: "无导购会员",
          value: "no_guider",
        },
        {
          label: "有导购会员",
          value: "guider",
        },
      ],
      strategyList: [
        {
          label: "绑定的导购",
          value: "guider",
        },
        /*{
          label: "绑定的管家",
          value: "housekeeper"
        },
        {
          label: "最近门店的导购",
          value: "shop"
        },*/
        {
          label: "指定客服组",
          value: "kf_group",
        },
      ],
      strategyRules: {
        strategyName: [
          { required: true, message: "请输入策略名称", trigger: "blur" },
        ],
        lastStrategy: [{ required: true, validator: strategyRuleFunc }],
        strategyUrl: [
          { required: true, message: "请刷新页面重新生成客服链接" },
        ],
      },
      customerServiceDesc: "@企业名称",
      title: "",
      row: {},
      type: "",
      serviceLink: "",
      strategyRow: {},
      strategyType: "",
      strategyTitle: "",
      employeeVisible: false,
      // 客服策略应用表格
      strategyTableList: [
        {
          strategyName: "商品详情",
        },
        {
          strategyName: "订单详情",
        },
        {
          strategyName: "个人中心客服",
        }
      ],
    };
  },
  created() {
    //this.initGetUrL();
    this.getInitInfo();
  },
  mounted() {},
  methods: {
    //查询企业微信客服装修模板链接
    async queryStrategyLinkUrl() {
      const { result } = await this.$store.dispatch("queryStrategyLinkUrl");
      this.strategyRuleForm.strategyUrl = result;
    },
    //删除成员
    delUserId(idnex) {
      this.ruleForm.userIds.splice(idnex, 1);
    },
    //保存成员
    saveEmployee() {
      this.ruleForm.userIds = JSON.parse(
        JSON.stringify(this.$refs.employeeSelect.selectDataList)
      );
      this.employeeVisible = false;
    },
    //添加成员
    addEmployee() {
      if (this.ruleForm.userIds && this.ruleForm.userIds.length > 0) {
        this.ruleForm.userIds.forEach((v) => {
          v.id = v.userid;
        });
      }
      this.employeeVisible = true;
      this.$nextTick(() => {
        this.$refs.employeeSelect.selectDataList = JSON.parse(
          JSON.stringify(this.ruleForm.userIds)
        );
      });
    },
    //策略删除
    strategyDel(row) {
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: row.id,
        };
        this.$store
          .dispatch("delCustomerServiceStrategy", params)
          .then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.queryList();
            }
          });
      });
    },
    //策略编辑
    strategyEdit(row) {
      this.strategyRuleForm = {
        strategyName: "",
        ruleList: [],
        lastStrategy: "",
        strategyUrl: "",
      };
      this.strategyTitle = "编辑策略";
      this.strategyType = "edit";
      this.strategyVisible = true;

      let item = JSON.parse(JSON.stringify(row));
      item.ruleList = JSON.parse(item.strategyInfo);
      this.strategyRuleForm = item;
    },
    //重置表单
    resetForm(fromName) {
      this.$nextTick(() => {
        this.$refs.resetForm.resetFields();
      });
    },
    //查询分组信息
    async queryCustomerServiceGroupList() {
      const { result } = await this.$store.dispatch(
        "queryCustomerServiceGroupList"
      );
      if (null == result) {
        this.customerGroupList = [];
      } else {
        this.customerGroupList = result;
      }
    },
    //获取初始化信息
    async getInitInfo() {
      // const { result } = null;
      const { result } = await this.$store.dispatch(
        "customerServiceGetInitInfo"
      );
      if (result == null) {
        this.initFlag = false;
        this.initGetUrL();
      } else {
        this.initFlag = true;
        this.queryCustomerServiceGroupList();
        this.queryList();
        // 获取企业微信商品订单客服关联信息
        this.queryKefuAppList()
      }
    },
    //获取url地址
    async initGetUrL() {
      const { result } = await this.$store.dispatch(
        "getInitCustomerServiceUrl"
      );
      this.initItem.linkUrl = result;
    },
    //删除
    clickDel(index) {
      this.strategyRuleForm.ruleList.splice(index, 1);
    },
    //上移
    clickUp(index) {
      this.strategyRuleForm.ruleList.splice(
        index - 1,
        1,
        ...this.strategyRuleForm.ruleList.splice(
          index,
          1,
          this.strategyRuleForm.ruleList[index - 1]
        )
      );
    },
    //下移
    clickDown(index) {
      this.strategyRuleForm.ruleList.splice(
        index,
        1,
        ...this.strategyRuleForm.ruleList.splice(
          index + 1,
          1,
          this.strategyRuleForm.ruleList[index]
        )
      );
    },
    //保存策略
    saveStrategy() {
      this.$refs.strategyRuleForm.validate((valid) => {
        if (valid) {
          let params = this.strategyRuleForm;
          params.strategyInfo = JSON.stringify(this.strategyRuleForm.ruleList);
          if (this.strategyType == "new") {
            this.$store
              .dispatch("saveCustomerServiceStrategy", params)
              .then((res) => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.strategyVisible = false;
                  this.queryList();
                }
              });
          } else {
            this.$store
              .dispatch("editCustomerServiceStrategy", params)
              .then((res) => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.strategyVisible = false;
                  this.queryList();
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    //添加策略规则
    addStrategyRule() {
      this.strategyRuleForm.ruleList.push({
        memberStrategy: "",
        ruleStrategy: "",
        kfStrategy: "",
      });
    },
    //添加策略
    addStrategy() {
      this.strategyRuleForm = {
        strategyName: "",
        ruleList: [],
        lastStrategy: "",
        strategyUrl: "",
      };
      this.strategyTitle = "添加策略";
      this.strategyType = "new";
      this.strategyVisible = true;
      this.queryStrategyLinkUrl();
    },
    //初始化完成
    initOver() {
      this.$refs.initItemRuleForm.validate((valid) => {
        if (valid) {
          let params = this.initItem.ruleForm;
          this.$store
            .dispatch("customerServiceInitConfig", params)
            .then((res) => {
              if (res.code === "0") {
                this.step = 5;
              }
            });
        }
      });
    },
    //下一步
    next(step) {
      console.log("step" + step);
      this.$refs.initItemRuleForm.validate((valid) => {
        console.log(valid);
        if (valid) {
          let params = this.initItem.ruleForm;
          this.$store
              .dispatch("customerServiceInitConfig", params)
              .then((res) => {
                if (res.code === "0") {
                  this.step = step;
                }
              });
        }
      });
    },
    //复制策略链接
    copyStrategyUrl() {
      const input = this.$refs.strategyUrl;
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功!",
        type: "success",
      });
    },
    //复制链接
    copyUrl() {
      const input = this.$refs.activityListUrl;
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功!",
        type: "success",
      });
    },
    //复制链接
    copyServiceLinkUrl() {
      const input = this.$refs.serviceLinkUrl;
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功!",
        type: "success",
      });
    },
    //添加
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let depIds = [];
          let userIds = [];
          this.ruleForm.userIds.forEach((v) => {
            if (v.type == "department") {
              depIds.push(v.id);
            } else {
              userIds.push(v.userid);
            }
          });
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.depIds = depIds.join(",");
          params.userIds = userIds.join(",");

          if (this.type == "new") {
            this.$store
              .dispatch("saveCustomerServiceGroup", params)
              .then((res) => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.addCustomerVisible = false;
                  this.queryCustomerServiceGroupList();
                }
              });
          } else {
            this.$store
              .dispatch("editCustomerServiceGroup", params)
              .then((res) => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.addCustomerVisible = false;
                  this.queryCustomerServiceGroupList();
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    uploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.pic = jsonData.result;
        // setTimeout(() => {
        //   this.show = false;
        // }, 0);
      }
    },
    // 正在上传
    uploading() {
      //   this.isSaving = true;
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning",
      });
      //   this.isSaving = false;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning",
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      return extension || extension2 || extension3 || extension4;
    },
    // 移除上传文件
    handleRemove(spreadBgp) {
      this.ruleForm[spreadBgp] = "";
    },
    //添加群组
    addCustomer() {
      this.ruleForm = {
        groupName: "",
        pic: "",
        userIds: [],
      };
      this.title = "新建客服组";
      this.type = "new";
      this.addCustomerVisible = true;
    },
    //执行更多
    doMore(command) {
      console.log("command", command);
      this.row = command.item;
      if (command.val == "edit") {
        this.ruleForm = {
          groupName: "",
          pic: "",
          userIds: [],
        };
        this.title = "编辑客服组";
        this.type = "edit";
        this.addCustomerVisible = true;
        let item = JSON.parse(JSON.stringify(command.item));
        item.userIds = [];
        item.groupName = item.name;
        item.pic = item.avatar;
        item.kfId = item.open_kfid;
        this.ruleForm = item;
      } else if (command.val == "cat") {
        this.ruleForm = {};
        this.catCustomerVisible = true;
        let item = JSON.parse(JSON.stringify(command.item));
        item.userIds = [];
        this.ruleForm = item;
        this.querySerivceLink();
      }
      this.queryServiceList();
    },
    async querySerivceLink() {
      let params = {
        kfId: this.row.open_kfid,
      };
      const { result } = await this.$store.dispatch("querySerivceLink", params);
      this.serviceLink = result;
    },
    async queryServiceList() {
      let params = {
        kfId: this.row.open_kfid,
      };
      const { result } = await this.$store.dispatch(
        "queryCustomerServiceList",
        params
      );
      this.ruleForm.userIds = result;
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryCustomerServiceStrategyList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    // 查询客服策略应用表单,获取企业微信商品订单客服关联信息
    async queryKefuAppList() {
      const userInfo = getLoginUser() || "";
      const params = {
        storeCode: userInfo.storeCode
      }
      const res = await this.$store.dispatch(
        "queryKefuAppList",
        params
      );
      console.log(res)
      if (res.code === "0") {
        let arr = res.result
        arr.forEach(v=>{
          if(v.type == "goods"){
            v.strategyPosition = "商品详情"
          } else if (v.type == "order") {
            v.strategyPosition = "订单详情"
          } else if (v.type == "customer") {
            v.strategyPosition = "个人中心客服"
          }
        })
        console.log(arr)
        this.strategyTableList = arr
      }
    },
    // 企业微信商品订单创建客服关联
    async queryGoodsOrderRelation(strategyUrl,type) {
      const userInfo = getLoginUser() || "";
      const params = {
        storeCode: userInfo.storeCode,
        strategyUrl,
        type
      }
      const res = await this.$store.dispatch(
        "queryGoodsOrderRelation",
        params
      );
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    // 选择策略
    strategySelect(row){
      let obj = {}
      // 下拉框内容来自list数组,根据选中值筛选
      obj = this.list.find(item=>{
        return item.strategyName === row.strategyName
      })
      // 传入选择的strategyUrl,以及这一行的type(goods或者order)
      this.queryGoodsOrderRelation(obj.strategyUrl,row.type)
    }
  },
};
</script>

<style scoped lang="scss">
.bg {
  background-color: #ffffff;
}
.title {
  color: rgba(34, 34, 34, 1);
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 16px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 3px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  .desc {
    color: #999999;
    font-size: 14px;
  }
}
.step1-style {
  .url {
    margin-top: 30px;
    width: 40%;
    padding: 18px 30px;
    background-color: rgba(229, 242, 252, 1);
    border-radius: 4px;
    .urlInput {
      width: 1px;
      opacity: 0;
      border: none;
    }
    .btn {
      background-color: #0081e5;
      color: #ffffff;
      border: 1px solid #0081e5;
      &.btn:hover {
        opacity: 0.8;
      }
    }
  }
}
.kfService {
  .urlInput {
    width: 1px;
    opacity: 0;
    border: none;
  }
}
.cl-url {
  width: 380px;
  display: inline-block;
  border-radius: 6px;
  border: 1px solid #dddddd;
  .urlInput {
    width: 1px;
    opacity: 0;
    border: none;
  }
}
.content-style {
  width: 200px;
  height: 68px;
  background: #ffffff;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 30px;
  margin-right: 30px;
  // &:nth-child(7n) {
  //   margin-right: 0;
  // }
}
.has-style {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
}
.notHas-style {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  border: 1px solid #e50065;
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    margin-left: 0;
    // padding: 10px;
    margin-right: 10px;
    width: 106px;
    height: 106px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.priview {
  position: relative;
  width: 106px;
  height: 106px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.user-style {
  width: 184px;
  border-radius: 4px;
  border: 1px solid #dddddd;
  margin-right: 20px;
  margin-bottom: 20px;
  padding: 10px 10px;
  position: relative;
  .guanBi {
    position: absolute;
    right: -8px;
    top: -20px;
    z-index: 99999;
    &.guanBi::before {
      background-color: #aaaaaa;
      border-radius: 50%;
      font-size: 18px;
      color: #fff;
    }
  }
}
.btn-blue {
  background-color: #0081e5;
  color: #ffffff;
  border: 1px solid #0081e5;
  &.btn-blue:hover {
    opacity: 0.8;
  }
}
.yuan {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #2fc348;
  .icon-duigou {
    line-height: 56px;
    text-align: center;
    color: #fff;
  }
}
.suc {
  color: #2fc348;
  font-size: 22px;
}
</style>
